import React, { useState, useEffect } from "react";
import { database } from "../firebaseConfig";
import { ref, get } from "firebase/database";
import { useNavigate } from "react-router-dom";
import ProductCard from "../components/ProductCard";
import { Helmet } from "react-helmet";
import "./OurProducts.css";
import { config } from '../config/config'
const API_URL = config.baseUrl;

const OurProducts = () => {
    const navigate = useNavigate();
    const [categories, setCategories] = useState([]);
    const [meta, setMeta] = useState(null);
    const [loading, setLoading] = useState(true);
    const [cardsPerRow, setCardsPerRow] = useState(5);

    // Update cardsPerRow responsively.
    useEffect(() => {
        const updateCardsPerRow = () => {
            setCardsPerRow(window.innerWidth <= 768 ? 2 : 5);
        };
        updateCardsPerRow();
        window.addEventListener("resize", updateCardsPerRow);
        return () => window.removeEventListener("resize", updateCardsPerRow);
    }, []);

    // Fetch all categories from Firebase (only the categories node).
    useEffect(() => {
        const fetchCategories = async () => {
            try {
                const snapshot = await get(ref(database, "categories"));
                if (snapshot.exists()) {
                    const data = snapshot.val();
                    // Convert data to array if needed.
                    const catArray = Array.isArray(data) ? data : Object.values(data);
                    setCategories(catArray);
                } else {
                    setCategories([]);
                }
            } catch (error) {
                console.error("Error fetching categories:", error);
            } finally {
                setLoading(false);
            }
        };
        fetchCategories();
    }, []);

    // Fetch SEO meta data from the categoryMeta node.
    useEffect(() => {
        const fetchCategoryMeta = async () => {
            try {
                const metaSnapshot = await get(ref(database, "categoryMeta"));
                if (metaSnapshot.exists()) {
                    setMeta(metaSnapshot.val());
                }
            } catch (error) {
                console.error("Error fetching category meta data:", error);
            }
        };
        fetchCategoryMeta();
    }, []);

    // Navigate to the CategoryProducts page on category click.
    const handleCategoryClick = (cat) => {
        navigate(`/category/${encodeURIComponent(cat.category)}`);
    };

    if (loading) {
        return (
            <div className="loading-container" style={{ width: "100%" }}>
                <img
                    src={`${API_URL}uploads/loading.gif`}
                    alt="Loading..."
                    className="loading-gif"
                    style={{ width: "100%" }}
                />
            </div>
        );
    }

    return (
        <div className="our-products-page">
            {/* SEO Meta Data */}
            <Helmet>
                <title>{meta?.title || "Categories"}</title>
                <meta name="description" content={meta?.description || "Browse our product categories."} />
                <meta name="keywords" content={meta?.keywords || "categories, products, shop"} />
            </Helmet>
            <button
                onClick={() => navigate(-1)}
                style={{
                    // position: "absolute",
                    top: "20px",
                    left: "20px",
                    width: "40px",
                    height: "40px",
                    borderRadius: "50%",
                    backgroundColor: "#f8d7da",
                    border: "none",
                    fontSize: "20px",
                    fontWeight: "bold",
                    cursor: "pointer",
                    color: "#333",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    transition: "background-color 0.3s ease",
                }}
                onMouseOver={(e) => (e.currentTarget.style.backgroundColor = "#c2185b")}
                onMouseOut={(e) => (e.currentTarget.style.backgroundColor = "#f8d7da")}
                aria-label="Go back"
            >
                ←
            </button>
            <h1 className="our-products-title">Categories</h1>
            <div
                className="categories-grid"
                style={{ gridTemplateColumns: `repeat(${cardsPerRow}, 1fr)` }}
            >
                {categories.map((cat, index) => (
                    <div
                        key={index}
                        className="category-card-wrapper"
                        onClick={() => handleCategoryClick(cat)}
                        style={{ cursor: "pointer" }}
                    >
                        <ProductCard
                            title={cat.category}
                            description={""}
                            price={cat.price || ""}
                            discount={cat.discount || ""}
                            rating={cat.rating || ""}
                            mediaUrl={cat.categoryUrl || "https://via.placeholder.com/300x200"}
                            mediaType="image"
                            edit={false}
                            cardsPerRow={cardsPerRow}
                            cardsPerRowPhoneView={2}
                        />
                    </div>
                ))}
            </div>
        </div>
    );
};

export default OurProducts;
